/* eslint-disable no-template-curly-in-string */
// @flow

export default {
  NoRecordsFound: 'No records found.',
  NothingHereYet: 'Nothing here yet',
  DocumentIndex: 'Document index',
  SubmissionIndex: 'Submission index',
  Search: 'Search',
  Searching: 'Searching...',
  Filter: 'Filter',
  FullTextSearch_SentenceCase: 'Full text search',
  BulkDownload_SentenceCase: 'Bulk download',
  ExportToExcel: 'Export to Excel',
  ExpandAll_SentenceCase: 'Expand all',
  CollapseAll_SentenceCase: 'Collapse all',
  BulkDownloadName_SentenceCase: 'Package name',
  SelectAll_SentenceCase: 'Select all',
  AskQuestion: 'Ask a Question',
  Move: 'Move',
  Edit: 'Edit',
  OpenInOfficeOnline: 'Open in Microsoft Office for the web',
  EditInOfficeOnline: 'Edit in Microsoft Office for the web',
  Security: 'Security',
  Enable: 'Enable',
  Disable: 'Disable',
  Delete: 'Delete',
  History: 'History',
  History_LowerCase: 'history',
  ManageDocuments: 'Manage documents',
  SelectDocumentsToRedact: 'Select the documents to redact',
  Submissions: 'Submissions',
  TenderSubmissions: 'Tender submissions',
  Add: 'Add',
  Folder: 'Folder',
  Document: 'Document',
  Document_LowerCase: 'document',
  Documents_LowerCase: 'documents',
  Folder_LowerCase: 'folder',
  Folders_LowerCase: 'folders',
  DocumentsAndFolders_LowerCase: 'documents and folders',
  Renumber: 'Renumber',
  BulkUpload_SentenceCase: 'Bulk upload',
  BulkDownloadOverDownloadLimit:
    'You have reached the download size limit of 100 GB. Please remove files from the selection to continue.',
  Name_: 'Name:',
  Number_: 'Number:',
  Retry: 'Retry',
  FolderNotDeletedAccess:
    'ERROR: The folder could not be deleted because it contains one or more documents and/or subfolders that you are not allowed to access.',
  FolderNotDeleted: 'ERROR: The Folder could not be deleted.',
  DocumentNotDeleted: 'ERROR: The Document could not be deleted.',
  FolderNotUpdated: 'ERROR: The Folder could not be updated.',
  DocumentNotUpdated: 'ERROR: The Document could not be updated.',
  ParentFolderDisabled: 'Parent folder is disabled',
  EnableDocument:
    'This folder contains 1 document, are you sure you want to enable this folder?',
  EnableDocuments: '\u003cb\u003eEnable\u003c/b\u003e Documents',
  EnableFolder:
    'This folder contains 1 folder, are you sure you want to enable this folder?',
  EnableFolderDocument:
    'This folder contains 1 folder and 1 document, are you sure you want to enable this folder?',
  EnableFolderDocuments:
    'This folder contains 1 folder and ${NumberOfDocuments} documents, are you sure you want to enable this folder?',
  EnableFolders:
    'This folder contains ${NumberOfFolders} folders, are you sure you want to enable this folder?',
  EnableFoldersDocument:
    'This folder contains ${NumberOfFolders} folders and 1 document, are you sure you want to enable this folder?',
  EnableFoldersDocuments:
    'This folder contains ${NumberOfFolders} folders and ${NumberOfDocuments} documents, are you sure you want to enable this folder?',
  BulkEnableFolders: '${NumberOfFolders} folders will be enabled.',
  BulkEnableFoldersWithImplicitFolders:
    'To enable these items all parent folders must be enabled. ${NumberOfFolders} folders will be enabled.',
  BulkEnableOneFolder: '1 folder will be enabled.',
  BulkEnableOneFolderAndDocuments:
    '1 folder and ${NumberOfDocuments} documents will be enabled.',
  BulkEnableOneFolderAndDocumentsWithImplicitFolders:
    'To enable these items all parent folders must be enabled. 1 folder and ${NumberOfDocuments} documents will be enabled.',
  BulkEnableOneFolderAndOneDocument: '1 folder and 1 document will be enabled.',
  BulkEnableOneFolderAndOneDocumentWithImplicitFolders:
    'To enable these items all parent folders must be enabled. 1 folder and 1 document will be enabled.',
  BulkEnableDocuments: '${NumberOfDocuments} documents will be enabled.',
  BulkEnableOneDocument: '1 document will be enabled.',
  BulkEnableFoldersAndOneDocument:
    '${NumberOfFolders} folders and 1 document will be enabled.',
  BulkEnableFoldersAndOneDocumentWithImplicitFolders:
    'To enable these items all parent folders must be enabled. ${NumberOfFolders} folders and 1 document will be enabled.',
  BulkEnableFoldersAndDocuments:
    '${NumberOfFolders} folders and ${NumberOfDocuments} documents will be enabled.',
  BulkEnableFoldersAndDocumentsWithImplicitFolders:
    'To enable these items all parent folders must be enabled. ${NumberOfFolders} folders and ${NumberOfDocuments} documents will be enabled.',
  BulkEnableDocumentsErrorMessage:
    'ERROR: ${NumberOfDocuments} document(s) could not be enabled.',
  BulkEnableFoldersErrorMessage:
    'ERROR: ${NumberOfFolders} folder(s) could not be enabled.',
  BulkEnableFoldersDocumentsErrorMessage:
    'ERROR: ${NumberOfFolders} folder(s) and ${NumberOfDocuments} document(s) could not be enabled.',
  DisableDocument:
    'This folder contains 1 document, are you sure you want to disable this folder?',
  DisableDocuments: '\u003cb\u003eDisable\u003c/b\u003e Documents',
  DisableFolder:
    'This folder contains 1 folder, are you sure you want to disable this folder?',
  DisableFolderDocument:
    'This folder contains 1 folder and 1 document, are you sure you want to disable this folder?',
  DisableFolderDocuments:
    'This folder contains 1 folder and ${NumberOfDocuments} documents, are you sure you want to disable this folder?',
  DisableFolders:
    'This folder contains ${NumberOfFolders} folders, are you sure you want to disable this folder?',
  DisableFoldersDocument:
    'This folder contains ${NumberOfFolders} folders and 1 document, are you sure you want to disable this folder?',
  DisableFoldersDocuments:
    'This folder contains ${NumberOfFolders} folders and ${NumberOfDocuments} documents, are you sure you want to disable this folder?',
  DisableFolderConfirm:
    '"${FolderName}" folder contains other folders within, they will be disabled too.',
  BulkDisableFolders: '${NumberOfFolders} folders will be disabled.',
  BulkDisableOneFolder: '1 folder will be disabled.',
  BulkDisableOneFolderAndDocuments:
    '1 folder and ${NumberOfDocuments} documents will be disabled.',
  BulkDisableOneFolderAndOneDocument:
    '1 folder and 1 document will be disabled.',
  BulkDisableDocuments: '${NumberOfDocuments} documents will be disabled.',
  BulkDisableOneDocument: '1 document will be disabled.',
  BulkDisableFoldersAndOneDocument:
    '${NumberOfFolders} folders and 1 document will be disabled.',
  BulkDisableFoldersAndDocuments:
    '${NumberOfFolders} folders and ${NumberOfDocuments} documents will be disabled.',
  BulkDisableDocumentsErrorMessage:
    'ERROR: ${NumberOfDocuments} document(s) could not be disabled.',
  BulkDisableFoldersErrorMessage:
    'ERROR: ${NumberOfFolders} folder(s) could not be disabled.',
  BulkDisableFoldersDocumentsErrorMessage:
    'ERROR: ${NumberOfFolders} folder(s) and ${NumberOfDocuments} document(s) could not be disabled.',
  DeleteFileConfirmation: '"${FileName}" will be deleted immediately.',
  DeleteFolderConfirmation: '"${FolderName}" will be deleted immediately.',
  BulkDeleteFolders: '${NumberOfFolders} folders will be deleted.',
  BulkDeleteOneFolder: '1 folder will be deleted.',
  BulkDeleteOneFolderAndDocuments:
    '1 folder and ${NumberOfDocuments} documents will be deleted.',
  BulkDeleteOneFolderAndOneDocument: '1 folder and 1 document will be deleted.',
  BulkDeleteDocuments: '${NumberOfDocuments} documents will be deleted.',
  BulkDeleteOneDocument: '1 document will be deleted.',
  BulkDeleteFoldersAndOneDocument:
    '${NumberOfFolders} folders and 1 document will be deleted.',
  BulkDeleteFoldersAndDocuments:
    '${NumberOfFolders} folders and ${NumberOfDocuments} documents will be deleted.',
  BulkDeleteDocumentsErrorMessage:
    'ERROR: ${NumberOfDocuments} document(s) could not be deleted.',
  BulkDeleteFoldersErrorMessage:
    'ERROR: ${NumberOfFolders} folder(s) could not be deleted.',
  BulkDeleteFoldersDocumentsErrorMessage:
    'ERROR: ${NumberOfFolders} folder(s) and ${NumberOfDocuments} document(s) could not be deleted.',
  AddFolder: 'Add folder',
  AddDocument: 'Add document',
  CopyLink_SentenceCase: 'Copy link',
  SendToKira_SentenceCase: 'Send to Kira',
  Actions: 'Actions',
  Download: 'Download',
  DownloadPart: 'Download part ${number}',
  BulkDownloadIsNotSwitchedOnContactAdmin_Gen2:
    'Bulk download is not switched on. Contact the Administrator for more information',
  Disabled: 'Disabled',
  FileTypeUnknown: 'File',
  FileTypeAcrobat: 'Acrobat PDF',
  FileTypeArchive: 'Archive',
  FileTypeAudio: 'Audio file',
  FileTypeCode: 'Code',
  FileTypeContact: 'Contact',
  FileTypeEmail: 'Email',
  FileTypeExcel: 'Excel',
  FileTypeImage: 'Image',
  FileTypeLayoutAndDesign: 'Design document',
  FileTypePowerpoint: 'Powerpoint',
  FileTypeText: 'Text',
  FileTypeVideo: 'Video',
  FileTypeVisio: 'Visio',
  FileTypeWord: 'Word',
  SavingAllowed: 'Saving allowed',
  SavingDenied: 'Saving denied',
  PrintingAllowed: 'Printing allowed',
  PrintingDenied: 'Printing denied',
  FileExtensionEmpty: 'no extension',
  OneBulkDownloadInProgress: '1 bulk download in progress - ${progress}%',
  NumberOfBulkDownloadInProgress:
    '${number} bulk downloads in progress - ${progress}%',
  Cancel: 'Cancel',
  Expand: 'Expand',
  Collapse: 'Collapse',
  FolderEmpty: 'Folder empty',
  UseChromeToBulkUpload: 'Use Chrome to bulk upload documents and folders.',
  RenumberCallToAction: 'Renumber',
  Archives: 'Archives',
  BulkDownloadUnavailable:
    'Bulk download is currently unavailable. Please try again later',
  PreviewNotAvailable: 'Preview not available',
  DocumentIsTooLargeToPreview:
    'This document is too large to preview. You need to download the document to view it.',
  DocumentIsTooLargeToPreviewWithoutDownload:
    'This document is too large to preview',
  FileCannotBePreviewed: 'This file cannot be previewed.',
  OwnerHasSecuredThisDocument: 'Owner has secured this document',
  ThisDocumentIsSecuredWithAdobeRightsManagement:
    'This document is secured with Adobe Rights Management. You need Adobe Acrobat Reader and be online to view this document.',
  ThisDocumentIsSecuredWithMicrosoftRightsManagement:
    'This document is secured with Microsoft Rights Management. You need Microsoft Office and be online to view this document.',
  SecuredPdfHelpLink:
    'Learn more about \u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-pc\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eviewing PDF documents.\u003c/a\u003e',
  SecuredPdfHelpLinkMac:
    'Learn more about \u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-mac\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eviewing PDF documents.\u003c/a\u003e',
  SecuredDocHelpLink:
    'Learn more about \u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eviewing Office documents.\u003c/a\u003e',
  YourDownloadIsBeingPrepared: 'Your download is being prepared...',
  OwnerHasSecuredTheseDocuments: 'Owner has secured these documents',
  SecuredPdfAndDocHelpLink:
    'Learn more about \u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-pc\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eviewing PDF documents\u003c/a\u003e or \u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eOffice documents.\u003c/a\u003e',
  SecuredPdfAndDocHelpLinkMac:
    'Learn more about \u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-mac\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eviewing PDF documents\u003c/a\u003e or \u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eOffice documents.\u003c/a\u003e',
  DocumentsAreSecuredWithMicrosoftOrAdobeRightsManagement:
    'These documents are secured with Adobe Rights Management or Microsoft Rights Management. You need Adobe Acrobat Reader or Microsoft Office and be online to view these documents.',
  UnableToDownloadThisFileTryAgain: 'Unable to download this file.',
  DownloadStarted: 'Download Started',
  Close: 'Close',
  GotIt: 'Got It',
  Preview: 'Preview',
  DontShowThisAgain: 'Don\u0027t show this again',
  BulkDownloadPrepareTitle: 'Your download is being prepared...',
  BulkDownloadPrepareAwareMessage:
    'Please be aware the larger the download, the longer it can take to process.',
  BulkDownloadPrepareMessage:
    'An email will be sent to <strong>${email}</strong> when your download is ready.',
  BulkDownloadLimitError:
    'You have reached the download limit of ${limitedNumberOfItems} files or ${limitedFileSize}. Please remove files from the selection to continue.',
  LinkCopiedToClipboard: 'Link copied to clipboard',
  RestoreDocuments: 'Restore documents',
  RepairNumbering: 'Repair numbering',
  BulkUpdate: 'Bulk update',
  GenerateFolders: 'Generate folders',
  NotificationsReport: 'Notifications report',
  DownloadHelpInfo:
    "If download hasn't started after a few seconds, please use a",
  DirectLink: 'direct link',
  YourDocumentsAreDownloading: 'Your documents are downloading.',
  DocumentRenamed: 'Document has been renamed.',
  FolderRenamed: 'Folder has been renamed.',
  FolderRenamedRenumber: 'Renumber to update the folder contents',
  DocumentsNotificationList: 'Document Notifications List',
  UserDocumentNotificationSettings: 'User Document Notifications Settings',
  IntervalType: 'Interval Type',
  NumberOfUsers: 'Number of Users',
  NotificationList: 'Notifications List',
  ExportSelectedItemsToExcel: 'Export [Number] To Excel',
  ToEmail: 'To Email',
  FromSentDateSydneyTime: 'From Sent Date (Sydney Time)',
  ToSentDateSydneyTime: 'To Sent Date (Sydney Time)',
  DocID: 'Doc ID',
  DocName: 'Doc Name',
  To: 'To',
  UserType: 'User Type',
  SentDateSydneyTime: 'Sent Date (Sydney Time)',
  Previous: 'Previous',
  Next: 'Next',
  DisableFolderConfirmHeader: 'You are about to disable a folder',
  ThereAreNoAvailableFoldersAndDocumentsAtTheMoment:
    'There are no available documents or folders at the moment.',
  ThereAreNoDocumentsOrFoldersMatchingFilterCriteria:
    'There are no documents or folders matching filter criteria.',
  DeleteFolderConfirmHeader: 'You are about to delete a folder',
  DeleteFileConfirmHeader: 'You are about to delete a file',
  MoveItemDialogUseDestinationFolderSecurity:
    'Use folder security settings from ${destinationFolderName}',
  MoveItemDialogSecuritySettingsLabel: 'Security Settings',
  MoveItemDialogUseCurrentFolderSecurity: 'Use current security settings',
  MoveItemDialogNotifyCheckbox: 'Notify people when access is granted',
  MoveItemNewLocation: 'New location: ',
  DontHavePermissionToMoveFolder:
    "You don't have permission to move this folder.",
  DontHavePermissionToMoveFolders:
    "You don't have permission to move these folders.",
  DontHavePermissionToMoveItemsMoveIntoFolder:
    "You don't have permission to move items into this folder.",
  SecuredFileIsTooLargeToPreview:
    "The file you're trying to preview is too large. You can download it instead.",
  SecuredFileIsTooLargeToPreviewWithoutDownload:
    "The file you're trying to preview is too large.",
  BeforeYouDownload: 'Before you download',
  SecuredPreviewPdfHelpLink:
    '\u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-pc\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eLearn more about viewing PDF documents.\u003c/a\u003e',
  SecuredPreviewPdfHelpLinkMac:
    '\u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-mac\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eLearn more about viewing PDF documents.\u003c/a\u003e',
  SecuredPreviewDocHelpLink:
    '\u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eLearn more about viewing Office documents.\u003c/a\u003e',
  StartYourDataRoomAndAddDocument: 'Start your data room and add documents.',
  UploadDocuments: 'Upload documents',
  ExpiredDocumentAccess:
    'Your access to this document has expired. Contact the data room administrator to gain access.',
  MultipleDragDropInfo: 'Select, drag and drop documents and folders to move',
  DemoMultipleDragDropTitle: 'How it works',
  Zipping: 'Zipping',
  Processing: 'Processing...',
  YourFilesAreReadyToDownload: 'Your files are ready to download',
  ThisBulkDownloadIsSplit:
    'This download is too large and we have split it into multiple parts. These links can also be found in your email.',
  BulkDownloadEmptyFoldersNote: 'Empty folders will not be downloaded.',
  NotifyPeopleWhenAccessIsGranted: 'Notify people when access is granted',
  BulkEnableConfirmHeader: 'Enable folders and documents',
  BulkDisableConfirmHeader: 'Disable folders and documents',
  CopyDocumentsInProgress: 'Document index load in progress',
  SomeDocumentsAreSecuredLink:
    'Some documents are secured by Administrator. To open them you need:',
  EnableTruncation: 'Enable Truncation',
  OptimizeFilePathForWindows: 'Optimize file path for Windows',
  TruncationNoteForWindows:
    'For Windows users, you need to use 7-Zip on Windows 10 to extract.',
  Restore: 'Restore',
  Current: 'Current',
  AddedBy: 'Added by',
  UpdatedBy: 'Updated by',
  RestoreThisVersion: 'Restore this version',
  AdobeAcrobatReader: 'Adobe Acrobat Reader',
  MicrosoftOffice: 'Microsoft Office',
  InternetConnection: 'Internet connection',
  BulkDeleteConfirmHeader: 'Delete folders and documents',
  Preparing: 'Preparing...',
  SomeSavingDeniedFilesSelected:
    '${number} documents have "Saving Denied" policy and will not be downloaded.',
  RestoreDocumentSuccessMessage: '${title} has been restored',
  RestoreVersionNumberButtonText: 'Restore version ${versionNumber}',
  HistoryDialogNothingChangeMessage:
    'This version is the same as the current version',
  HistoryDialogNoDocumentChangeMessage: 'Document content has not been changed',
  HistoryDialogNoNameAndNumberChangeMessage:
    'Name and number of the document have not been changed',
  ResetViewAsToDownload: 'Reset "View as" filter to download.',
  NoPermissionToDownloadTooltip:
    'Administrator has disabled bulk download for this room',
  Remove: 'Remove',
  Reset: 'Reset',
  ResetNow: 'Reset now',
  ResetDialogTitle: 'Reset submission process',
  ResetDialogContent:
    'Are you sure you want to reset submission process? The closing date and time will be reset.',
  Confirm: 'Confirm',
  Region: 'Region',
  KiraSuccessfullyConnectedTitle: 'Successfully connected to Kira',
  KiraSuccessfullyConnectedFirstLine:
    'You can now send documents to Kira to uncover',
  KiraSuccessfullyConnectedSecondLine:
    'relevant information from contracts and related documents.',
  KiraProjectsLoading: 'Projects loading...',
  KiraSelectProject: 'Select a project in Kira...',
  KiraSendDocument: 'Send document to Kira',
  KiraConnect: 'Connect to Kira',
  KiraCompanyUrl: 'Your Kira company URL',
  KiraApiToken: 'Kira API token',
  KiraUnableToConnect:
    'We were unable to connect to Kira. Please verify your region and token and try again.',
  KiraConfigError:
    'Something went wrong loading configuration. Please try again.',
  KiraProjectsLoadError:
    'We were unable to fetch your projects from Kira. Please try again.',
  KiraSendDocumentError:
    'Something went wrong pushing document to Kira. Please try again.',
  KiraSendingDocument: "Sending '${documentName}' to Kira",
  KiraDocumentSent: "'${documentName}' sent to Kira",
  Redact: 'Redact',
  RedactDocuments: 'Redact documents',
  EditRedact: 'Edit redaction',
  RedactionIsNotAvailable: 'Redaction is not available',
  RedactGetDocumentError:
    'We were unable to get this document. Please try again',
  RedactBurnDocumentError:
    'We were unable to redact this document. Please try again',
  RedactFileTooLarge:
    'Files larger than ${fileSize} are not supported for redaction at the moment. Optimize document size and try again.',
  RedactSaveDialogTitle: 'Save as new redacted document',
  MultipleDocumentsErrorDescription:
    '${numberOfDocuments} documents marked were unable to be processed. You can try and upload the document again.',
  SingleDocumentErrorDescription:
    '1 document marked was unable to be processed. You can try and upload the document again.',
  MultipleDocumentsInProgressDescription:
    '${numberOfDocuments} documents marked have not finished processing.',
  SingleDocumentInProgressDescription:
    '1 document marked has not finished processing.',
  CancelBulkRedaction: 'Cancel bulk redaction',
  CancelBulkRedactionMessage: `You are about to stop the redaction process.
  Stopping redaction will cease redaction on current document and return you to the document index.`,
  cannotCreateDocumentInTheFolderMovedFromWorkFlow:
    'You cannot copy documents into folders moved from Workflow.',
  StopRedaction: 'Stop redaction',
  DocumentLocation: 'Document location',
  FolderLocation: 'Folder location',
  CannotSelectFoldersMovedFromWorkflow:
    ' (You cannot select folders moved from Workflow)',
  MovedFromWorkflow: 'Moved from Workflow',
  EmptyDocumentIndexAutoMoveMessage:
    'Documents and folders are automagically moved to the Document index when Workflow items are completed.',
  EmptyManageDocumentAutoMoveMessage:
    'Documents and folders are automagically moved to Manage Documents when Workflow items are completed. You can also add documents and folders here.',
  OpenWorkflow: 'Open Workflow',
  AddDocumentsAndFolders: 'Add documents and folders',
  SecurityControls: 'Security controls',
  SecuritySettings: 'Security settings',
  UseFolderSecurityFrom: 'Use folder security settings from',
  UseSecurityFromOpenedDocument: 'Use security settings from opened document',
  UseSecurityFromOriginalDocument:
    'Use security settings from original document',
  UseSecurityFromOriginalFolder: 'Use security settings from original folder',
  UseSecurityFromOriginalFoldersAndDocuments:
    'Use security settings from original folders and orignial documents',
  DocumentWillBeDisabledByDefault: 'Document will be disabled by default.',
  DocumentsAndFoldersWillBeDisabledByDefault:
    'Folders and documents will be disabled by default.',
  ImportDataRoomError:
    'Import with trackingId ${trackingId} is error. Please try again.',
  RedactionError: '${fileName} could not be redacted, please try again.',
  RedactionHowRedactionSavingWorks: 'How redaction saving works',
  RedactionEducationDialogForAdministrators: 'For Administrators',
  RedactionEducationDialogForGuests: 'For Guests',
  RedactionEducationDialogPreviewDownload: 'Preview/Download',
  RedactionEducationDialogEditing: 'Editing',
  RedactionEducationDialog1Layer: '1-layer document',
  RedactionEducationDialog2Layer: '2-layer document',
  RedactionEducationDialogRedactionsAreBakedIn: 'Redactions are baked-in',
  RedactionEducationDialogRedactionsAreEditable: 'Redactions are editable',
  RedactionSaveAsNewDocument: 'Save as a new document',
  RedactionHowSavingWorks: 'How saving works',
  ChangesYouMadedWillNotBeSaved: 'Changes you made will not be saved.',
  IsRedacted: 'is redacted.',
  DocumentsAddedFrom: 'Documents added from ${dataroomName}.',
  GoToFile: 'Show me the document',
  GoToImportFolder: 'Show me the folder',
  Thanks: 'Thanks',
  Validation_DuplicatedDocumentInFolder:
    'Document ${documentName} already exists in ${folderName}',
  Validation_NameCannotBeEmpty: 'Name cannot be empty.',
  Continue: 'Continue',
  RedactingMessage: 'Redacting might take a while. Please do not refresh',
  Name: 'Name',
  Number: 'Number',
  LearnMore: 'Learn more',
  BulkActionsNoItemsWillBeAffected:
    'No items will be affected by this operation.',
  Saving: 'Saving',
  YouCanKeepWorking: 'You can keep working.',
  Copy: 'Copy',
  CopyDocument: 'Copy document',
  CopyFolder: 'Copy folder',
  Import: 'Import',
  DataRooms: 'DataRooms',
  Accept: 'Accept',
  TermOfAccess: 'Term of access',
  TermOfAccessCheckbox: 'I have read, understood and agree to the terms',
  ImportingDataFrom: 'Adding documents from ${dataroomName}.',
  Refresh: 'Refresh',
  ImportTo: 'Import to',
  ImportError: 'Import error, please contact administrator.',
  Back: 'Back',
  LastAccessed: 'Accessed',
  NeverAccessed: 'Never accessed',
  Remaining: 'remaining',
  SubmissionWindowIsOpen: 'Submission window is open.',
  SubmissionWindowHasEnd:
    'Submission window has ended. Documents you upload now will be marked as late.',
  FromYourComputer: 'From your computer',
  FromAnotherDataRoom: 'From another data room',
  FromFolderStructure: 'From folder structure',
  FromDataRoom: 'From data room',
  AddFromDataRoom: 'Add from data room',
  AddFromFolderStructure: 'Add from folder structure',
  ImportDialogDataRoomScreenDialogTitle: 'Add documents from data room',
  ImportDialogDataRoomScreenHeading:
    'Choose the Data Room that contains the documents you want to add.',
  ImportDialogTermOfAccessScreenDialogTitle:
    'Add documents from ${dataroomName}',
  ImportDialogTermOfAccessScreenHeading:
    'You need to accept the Terms of Access before you can add documents from this data room.',
  ImportDialogDataRoomScreenRadioBtn: 'Add documents from this data room',
  ImportDialogDocumentListScreenHeading:
    'Choose one or more documents to add to your data room.',
  ImportDialogEmptyDataRoom: 'There are no data rooms that you can access.',
  ImportDialogEmptyDocument:
    'There are no documents to add from this data room.',
  ImportDialogDocumentListScreenDialogTitle:
    'Add documents from ${dataroomName}',
  UserTypeCode_ADM: 'Administrator',
  UserTypeCode_DOP: 'Publisher',
  UserTypeCode_GUE: 'Guest',
  UserTypeCode_USQ: 'LimitedViewer',
  UserTypeCode_USR: 'Viewer',
  QnaRoleCode_QVW: 'Question Viewer',
  QnaRoleCode_BAP: 'Bidder Approver',
  QnaRoleCode_BAA: 'Bidder Author',
  QnaRoleCode_BMC: 'Bidder Main Contact',
  QnaRoleCode_IAP: 'Internal Approver',
  QnaRoleCode_IAA: 'Internal Author',
  QnaRoleCode_IMC: 'Internal Main Contact',
  QnaRoleCode_IOB: 'Internal Observer',
  QnaRoleCode_QAU: 'Question Author',
  QnaRoleCode_QAP: 'Question Approver',
  QnaRoleCode_ADR: 'Answer Drafter',
  QnaRoleCode_AAU: 'Answer Author',
  QnaRoleCode_AAP: 'Answer Approver',
  QnaRoleCode_QAA: 'Q&A Administrator',
  QnaRoleCode_QAO: 'Q&A Observer Full Control',
  QnaRoleCode_QOV: 'Q&A Observer View Only',
  DemoRoom: '*DEMO* - ${dataroomName}',
  SearchDocuments_InputPlaceholder:
    'Enter a keyword, or name and number of a document or folder',
  SearchDocuments_Find: 'Find',
  SearchDocuments_Results: 'Results',
  SearchDocuments_FullTextSearchSummary:
    '${totalItems} document${plural} will match content',
  SearchDocuments_DocumentSummary:
    '${totalItems} document${plural} will match title and number and code',
  SearchDocuments_FolderSummary:
    '${totalItems} folder${plural} will match title and number and code',
  New: 'NEW',
  Browse: 'Browse',
  ImportFolder_GlobalActionButton: 'Import folder structure',
  ImportFolder_Title: 'Import your folder structure',
  ImportFolder_Step1_DragDropDescription1:
    'Drag and drop or browse an Excel file to import folders.',
  ImportFolder_Step1_DragDropDescription2:
    'Note: Folders are disabled on import.',
  ImportFolder_Step1_DragDropDescription3:
    'Format your Excel file with the folder number as column A and the folder name as column B or simply {0}',
  ImportFolder_Step1_FileUploaded: '{0} uploaded',
  ImportFolder_Step1_DownloadTemplateFile: 'Download excel template',
  ImportFolder_Step1_Heading: 'You are importing the folder structure into {0}',
  ImportFolder_Step1_ErrorMessage:
    'Your file didn’t upload. Try again with an .xls or .xlsx file.',
  ImportFolder_Step2_Title: 'Review and complete your import',
  ImportFolder_Step2_SuccessMessage: 'Your folders have been imported.',
  Document_Preview: 'Document preview',
  FileUnsupportedForPreview: `We can’t show you a preview of this file.
    You’ll need to download the file to view the contents.`,
  ErrorWhileDownloadingFile:
    'There is error while trying to download, please contact our Customer Support with ${ErrorCode}',
  CannotDownloadingFile: "Can't download file. ",
  ClickToSeeDetails: 'Click to see details',
  TryAgain: 'Try again',
  NumberingUpdatedFor: 'Numbering updated for',
  Items: 'items',
  YoureAboutToChangeTheNumberingOn: "You're about to change the numbering on",
  ThisMayHaveAnImpactOnPeopleReferencingTheDocumentOnThisProject:
    'This may have an impact on people referencing the document on this project.',
  AllDocuments: 'All documents',
  AllQnaAndAttachments: 'All Q&A and attachments',
  AllSubmissionDocuments: 'All submission documents',
  AllEvaluationAttachments: 'All evaluation attachments',
  AllUserActivityDocumentViewsReports:
    'All activity logs by person & document views reports',
  IncludeDocuments: 'Include Documents',
  IncludeSubmissionDocuments: 'Include Submission Documents',
  IncludeEvaluationAttachments: 'Include Evaluation Attachments',
  IncludeQna: 'Include Q&A',
  IncludeQnaAttachments: 'Include Q&A Attachments',
  IncludeDisabledDocuments: 'Include disabled documents',
  Documents: 'Documents',
  SubmissionDocuments: 'Submission documents',
  EvaluationAttachments: 'Evaluation attachments',
  QnaAttachments: 'Q&A attachments',
  DisabledDocuments: 'Disabled documents',
  DocumentsVisibleTo: 'Documents visible to',
  SubmissionDocumentsVisibleTo: 'Submission documents visible to',
  QnaAndAttachmentsVisibleTo: 'Q&A and attachments visible to',
  QnaAttachmentsVisibleTo: 'Q&A attachments visible to',
  QnaVisibleTo: 'Q&A visible to',
  IncludeDisabledDocumentsWarningMessage:
    'Including disabled documents will reveal documents not currently visible to the selected team. This option is not recommended.',
  AllSubTeams: 'All sub-teams',
  AllSecurityGroups: 'All security groups',
  NoSubTeams: 'No sub-teams',
  AdminOnlyFullArchive: 'Admin only - full archive',
  Team: 'Team',
  SubTeam: 'Sub-team',
  ArchiveName: 'Archive name',
  Options: 'Options',
  Summary: 'Summary',
  CreateArchive: 'Create archive',
  IncludeInArchive: 'Included in archive',
  VisibleTo: 'Visible to',
  SubmissionDocuments_LowerCase: 'submission documents',
  EvaluationAttachments_LowerCase: 'evaluation attachments',
  Qna: 'Q&A',
  QnaAndAttachments_LowerCase: 'Q&A attachments',
  DisableDocuments_LowerCase: 'disabled documents',
  Questions_LowerCase: 'questions',
  Attachments_LowerCase: 'attachments',
  DocumentViewsReports_LowerCase: 'document views reports',
  ActivityLogsByPerson_LowerCase: 'activity logs by person',
  InProgress: 'In progress',
  Expired: 'Expired',
  Failed: 'Failed',
  YourArchiveIsBeingGenerated: 'Your archive is being generated...',
  YourArchiveHasBeenQueued: 'Your archive has been queued.',
  AnEmailWillBeSentTo: 'An email will be sent to',
  WithADownloadLinkWhenTheArchiveIsReady:
    'with a download link when the archive is ready.',
  ContactSupport: 'Contact support',
  SomethingWentWrong: 'Something went wrong.',
  WeAreUnableToProcessYourArchiveRequest:
    'We are unable to process your archive request.',
  Retrieving: 'Retrieving',
  FullArchiveAdminOnly: 'Full archive - Admin only',
  Filtered: 'Filtered',
  CreateYourFirstArchive: 'Create your first archive',
  AutoTruncateHelpText:
    "We'll apply the best truncation to ensure file paths don’t exceed 260 characters.",
  Becomes_LowerCase: 'becomes',
  TruncationType: 'Truncation type',
  AutoTruncate: 'Auto truncate',
  DoNotTruncate: 'Do not truncate',
  KeepLastSegmentOfNumbers: 'Keep last segment of numbers',
  KeepNumbersOnly: 'Keep numbers only',
  KeepNamesOnly: 'Keep names only',
  FullArchiveHelpText_Old:
    'Data Room administrators can view all documents and Q&A attachments.',
  FullArchiveHelpText:
    'Accessible to Adminstrators and Viewers, <strong>a full archive</strong> includes all documents, attachments, Q&A and workflow tabs created internally and shared with guests.',
  ArchiveHelpText_Old:
    'We’ll include ${includedOptions} visible to ${teamOrSubTeamName}.',
  ArchiveHelpText:
    'We’ll include all ${includedOptions} visible to <strong>${teamOrSubTeamName}.</strong>',
  HowArchivesWork: 'How archives work',
  ArchivesContainTheFullFilePathForEveryArchivedDocument:
    'Archives contain the full file path for every archived document.',
  FilePathsAreLimitedTo260Characters:
    'File paths are limited to 260 characters.',
  YouMayNeedToTruncateTheFilePaths:
    'You may need to truncate the file paths so that you can view them on your computer.',
  YouCanUseAZipApplicationToViewArchivesWithLongFilePaths:
    'Alternatively, you can use a ZIP application to view archives with long file paths.',
  YourArchiveIsDownloading: 'Your archive is downloading.',
  DoNotTruncateHelpText:
    'You can use a ZIP application to extract documents with long file paths.',
  Share: 'Share',
  SecureShare_Capitalize: 'Secure Share',
  SecureShare_SentenceCase: 'Secure share',
  ValidateEmailToView: 'Validate email to view',
  ValidateEmailToViewDescription:
    'People will need to validate their email address before viewing the document.',
  EnterPasscodeToView: 'Enter passcode to view',
  EnterPasscodeToViewDescription:
    'Set a passcode for people to enter before they can view the document.',
  AnyoneWithALinkCanView: 'Anyone with a link can view',
  AnyoneWithALinkCanViewDescription:
    'People with the link will have unsecured access to the document.',
  NoAccess: 'No access',
  NoAccessDescription:
    'People with shared links can no longer view the document.',
  SecureShareLinkSettings: 'Control access to your shared link',
  Watermark: 'Watermark',
  LinkExpiresIn: 'Link expires in ${duration} (${timezone})',
  LinkExpiredDuration: 'Link has expired ${duration} ago (${timezone})',
  LinkExpirationDate: 'Set a date and time to expire the link',
  On: 'On',
  Off: 'Off',
  CreateWatermark: 'Create watermark',
  None: 'None',
  YouAreReadyToShare: 'You’re ready to share',
  WeHaveCopiedTheSecureShareLinkToYourClipboard:
    'We’ve copied the secure link for <strong data-ansarada-ccd="true">${fileName}</strong> to your clipboard.',
  AnyoneWithTheLinkCanviewTheDocument:
    'Anyone with the link can view the document.',
  PeopleNeedToValidateTheirEmailToViewTheDocument:
    'People need to validate their email to view the document.',
  PeopleNeedToEnterThePasscodeToViewTheDocument:
    'People need to enter the passcode (<strong data-ansarada-ccd="true">${passCode}</strong>) to view the document.',
  SecureShareLink: 'Secure Share link',
  SecureShareLinkCopy: 'Secure link for you to copy and share',
  SaveAndRemoveAccess_SentenceCase: 'Save and remove access',
  AccessPasscode: 'Enter a passcode to access the link',
  SettingsSaved: 'Settings saved',
  WeHaveExpiredAllSecureShareLinks:
    'We’ve expired all Secure Share links for <strong data-ansarada-ccd="true">${fileName}</strong>.',
  LinkShareWithCode: 'Link share with code',
  LinkShareWithEmail: 'Link share with email',
  LinkShare: 'Link share',
  AllDownloadedCopiesWillSelfDestruct:
    'All downloaded copies will self destruct.',
  NeedHelpSharingALinkOrDocument: 'Need help sharing a link or document?',
  HowDoIExpireAllLinksToADocument: 'How do I expire all links to a document?',
  WhatDoIDoToDenyADownload: 'What do I do to deny a download?',
  FindOutMoreAboutSecureShare: 'Find out more about sharing documents securely',
  SaveAndCopyLink_SentenceCase: 'Save and copy link',
  ShareDocumentSecurely_SentenceCase: 'Share document securely',
  ShareDocumentEmptyStateDescription:
    'Choose a document from the manage documents column to start sharing.',
  FirstTellUsWhoYouAre: 'First, tell us who you are',
  ToAccessTheSharedDocumentWeNeedToVerifyYourEmailAddress:
    'To access the shared document, we need to verify your email address.',
  WeWillSendYouAnEmailSoYouCanAccessTheSharedDocument:
    'We will send you an email so you can access the shared document.',
  EnterAnEmailAddress: 'Enter an email address',
  EnterAValidEmailAddress: 'Enter a valid email address',
  EmailIsRequired: 'Email is required',
  VerifyMyEmail_SentenceCase: 'Verify my email',
  FirstEnterThePasscode: 'First, enter the passcode',
  ToAccessTheSharedDocumentYouNeedToEnterThePasscode:
    'To access the shared document, you need to enter the passcode.',
  ReachOutToThePersonWhoSharedDocumentYouNeedToEnterThePasscode:
    'Reach out to the person who shared the link with you to find out more.',
  EnterTheAccessPasscode: 'Enter the access passcode',
  ViewDocument_SentenceCase: 'View document',
  TheDocumentIsNoLongerAvailable: 'The document is no longer available',
  YourAccessMayHaveBeenRemovedOrTheDocumentDeleted:
    'Your access may have been removed or the document deleted.',
  ReachOutToThePersonWhoSharedTheLinkWithYouToFindOutMore:
    'Reach out to the person who shared the link with you to find out more.',
  SecurityControlsOn: 'Security controls on',
  SecurityControlsOff: 'Security controls off',
  CopyingAllowed: 'Copying allowed',
  CopyingDenied: 'Copying denied',
  EditingAllowed: 'Editing allowed',
  EditingDenied: 'Editing denied',
  DenyCopyingDisabled: 'Deny copying disabled',
  DenyEditingDisabled: 'Deny editing disabled',
  DenyPrintingDisabled: 'Deny printing disabled',
  DenySavingDisabled: 'Deny saving disabled',
  Redirecting: 'Redirecting...',
  CheckYourInbox: 'Check your inbox',
  YouAreOnADifferentDevice: 'You’re on a different device',
  YouCanOnlyViewThisDocumentFromTheSameDeviceUsedToVerifyYourEmail:
    'You can only view this document from the same device used to verify your email.',
  WeHaveSentAnEmailToYourEmail: 'We’ve sent an email to ',
  WithTheAccessToViewTheDocument: ' with the access to view the document.',
  ViewActivity: 'View activity',
  PasscodeIsNotCorrect: 'Passcode is not correct',
  SubmissionDocumentUploaded: '1 document uploaded into submission.',
  SubmissionDocumentsUploaded:
    '${NumberOfDocuments} documents uploaded into submission.',
  HowSubmissionsWork: 'How submissions work',
  AllAddedDocumentsAreAutomaticallySubmitted:
    'All added documents are automatically submitted.',
  YouHaveUntilTheCloseOfTheSubmissionWindowToMakeChanges:
    'You have until the close of the submission window to make changes.',
  UntilClose: 'until close',
  Ansarada: 'Ansarada',
  BulkEditFileUpload: `or drag and drop your refined Excel here. We'll present a crisp
  overview of the edits.`,
  BulkEditFileUploadAfterUploading:
    'or drag and drop the correct file here to switch seamlessly.',
  BulkEditExcelReady: 'On Point, ${name}! Got your edited Excel ready?',
  BeforeYourEdits: 'Before your edits',
  AfterYourEdits: 'After your edits',
  DropFilesHereToAttach: 'Drop files here to attach',
  KickOffBy: 'Kick-off by',
  DownloadingTheExcelVersion: 'downloading the Excel version',
  OfYourDocumentIndex: 'of your Document Index.',
  BulkEditNextButtonGuide:
    'After fine-tuning, tap the <strong>Next</strong> button to upload and witness efficiency in action.',
  BulkEditDownloadExcelFileHeading:
    'Elevate Your Workflow: Editing Documents Made Seamless.',
  BulkEditAllSetHeading: "All set, ${name}! You're primed for action.",
  BulkEditButtonGuide:
    "Once you hit the <strong>Bulk edit</strong> button, we're set to tweak ${combinedText} as per your directives.",
  HeadsUpThough: `<strong>Just a heads-up:</strong> We won’t apply at least one edit. The administrators removed them from the Document Index.`,
  ProTip: 'A pro-tip?',
  ProTipDescription:
    "Consider downloading the latest Excel version of your Document Index. It'll give you a pristine snapshot before the edits kick in.",
  GrabItHere: 'Grab it here.',
  BulkEditSuccessMessage: `Your bulk update is applied and now in the Document Index. We've got your back!`,
  NotTheRightExcel: 'Not the right Excel?',
  UploadFailedMessage:
    'Upload Failed, ${name}. An issue occurred while uploading. Please try again.',
  FailedMessage:
    'Update Failed, ${name}. An issue occurred with the bulk update. Please try again.',
  DoNotHaveAccessMessage:
    'You do not have access to some of changed documents & folders in provided Excel, please ask Data Room administrator to perform the operation',
  ManagingLongFilePaths: 'Managing long file paths',
  CreateArchiveInformation:
    'By default, we auto-truncate your data room documents and attachments to meet the common <strong>260-character file path limit.</strong>',
  CreateArchiveInstruction:
    'If you can’t view archived documents due to long file paths, try a different truncation method or use file archiver tools like 7zip to access them.',
  DocumentTruncation: 'Document truncation',
  WorkflowTabs_LowerCase: 'workflow tabs',
  Workflow: 'Workflow',
  WorkflowAttachments: 'Workflow attachments',
  WorkflowAttachments_LowerCase: 'workflow attachments',
  WorkflowExport_LowerCase_Singular: 'workflow export',
  WorkflowExport_LowerCase_Plural: 'workflow exports',
  WorkflowAttachments_LowerCase_Singular: 'workflow attachment',
  WorkflowAttachments_LowerCase_Plural: 'workflow attachments',
  WorkflowExport_LowerCase: 'workflow export',
};
